export const DOOR_SYSTEM = {
  STATUS: {
    OUTER_DOOR_COMMUNICATION_ERROR: 1,
    OUTER_DOOR_OUT_OF_SERVICE: 1,
    OUTER_DOOR_MAJOR_ERROR: 1,
    OUTER_DOOR_MINOR_ERROR: 1,
    OUTER_DOOR_FULLY_OPEN: 1,
    OUTER_DOOR_ENABLED: 1,
    OUTER_DOOR_CLOSED_AND_LOCKED: 1,
    END_DOOR_COMMUNICATION_ERROR: 1,
    END_DOOR_MAJOR_ERROR: 1,
    END_DOOR_MINOR_ERROR: 1,
    END_DOOR_LOCKED: 1,
    INNER_DOOR_COMMUNICATION_ERROR: 1,
    INNER_DOOR_MAJOR_ERROR: 1,
    INNER_DOOR_MINOR_ERROR: 1,
    INNER_DOOR_LOCKED: 1,
    BISTRO_COMMUNICATION_ERROR: 1,
    BISTRO_DOOR_MAJOR_ERROR: 1,
    BISTRO_DOOR_MINOR_ERROR: 1,
    BISTRO_DOOR_LOCKED: 1,
    PRM_DOOR_ACTIVE: 1
  }
} as const;
